<template>
  <div>
    <h2>Pick a template, dude</h2>

    <button v-for="(template, index) in templates" :key="template.title+index" v-on:click="doWhateverTheRandomizeFunctionIs(template.choices)">
      {{template.title}}
    </button>

    <button v-on:click="$emit('cancel')" class="cancel">Nevermind. Cancel.</button>
  </div>
</template>

<script>
export default {
  name: 'Templates',
  data: function() {
    return {
      templates: [
        {
          title: "Chores",
          choices: [
            "Put things away",
            "Do the laundry",
            "Wash the dishes",
            "Dust & Vacuum",
            "Sweep & Mop",
            "Water the plants",
            "Feed the pets",
            "Take out the trash"
          ]
        },
        {
          title: "Colors",
          choices: [
            "Red",
            "Green",
            "Brown",
            "Blue",
            "Orange",
            "Yellow",
            "Purple",
            "Black",
            "White"
          ]
        },        
        {
          title: "Dinners",
          choices: [
            "Pizza",
            "Bacon cheeseburgers",
            "Quesadillas",
            "Tacos",
            "Sandwiches",
            "Soup & Salad",
            "Chinese Food",
            "Fish/Seafood",
            "Steak",
            "Chicken"
          ]
        },
        {
          title: "Cheese",
          choices: [
            "Mozzerella",
            "Cheddar",
            "Monterey Jack",
            "Colby",
            "Gouda",
            "Muenster",
            "Swiss",
            "Brie",
            "Muenster",
            "Provolone",
            "Feta",
            "Ricotta"
          ]
        }        
      ]
    }
  },
  methods: {
    doWhateverTheRandomizeFunctionIs: function(choices) {
      this.$emit('setsticks', choices);
    },
    addLocal(){
      let existingTemps = JSON.parse(localStorage.getItem("localTemplates"))
      if(existingTemps == null) return
      this.templates = [...this.templates, ...existingTemps]
    }
  },
  mounted() {
    this.addLocal();
  },
}
</script>